// extracted by mini-css-extract-plugin
module.exports = {"searchHeaderWrapper":"sources-details_searchHeaderWrapper__1BlXl","searchField":"sources-details_searchField__3gqkS","modal":"sources-details_modal__3iXMD"};